import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Logo } from "./Logo";
import * as Icons from "lucide-react";

export const DynamicHeader = ({ mode = 'c2b' }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // B2B Navigation
  const b2bNav = [
    { label: "Laptop-Ankauf", path: "/b2b/laptop-ankauf" },
    { label: "Remarketing", path: "/b2b/remarketing" },
    { label: "Datensicherheit", path: "/b2b/datensicherheit" },
    { label: "Ablauf", path: "/b2b/ablauf" },
    { label: "Über uns", path: "/about" },
  ];

  // Private Navigation
  const c2bNav = [
    { label: "Laptop verkaufen", path: "/c2b/laptop-verkaufen" },
    { label: "Smartphone verkaufen", path: "/c2b/smartphone-verkaufen" },
    { label: "So funktioniert's", path: "/c2b/so-funktionierts" },
    { label: "Vorteile", path: "/c2b/vorteile" },
    { label: "FAQ", path: "/c2b/faq" },
  ];

  const navItems = mode === 'b2b' ? b2bNav : c2bNav;
  const ctaLabel = mode === 'b2b' ? 'Firmenangebot anfordern' : 'Jetzt Gerät anbieten';
  const ctaPath = mode === 'b2b' ? '/request-quote' : '/c2b/geraet-anbieten';

  return (
    <header
      className={`sticky top-0 z-30 transition-all duration-300 ${
        isScrolled
          ? "bg-white/95 backdrop-blur-md shadow-md"
          : "bg-white"
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <Logo className="h-8 w-8 lg:h-10 lg:w-10" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6 ml-16">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                location.pathname === "/"
                  ? "text-[#1f7db6] bg-[#1f7db6]/10"
                  : "text-gray-700 hover:text-[#1f7db6] hover:bg-gray-50"
              }`}
            >
              Home
            </Link>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === item.path
                    ? "text-[#1f7db6] bg-[#1f7db6]/10"
                    : "text-gray-700 hover:text-[#1f7db6] hover:bg-gray-50"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block flex-shrink-0">
            <Link to={ctaPath}>
              <Button className="bg-[#1f7db6] hover:bg-[#143e6e] text-white font-medium shadow-md">
                {ctaLabel}
                <Icons.ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-[#1f7db6]"
          >
            {isMobileMenuOpen ? <Icons.X size={24} /> : <Icons.Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-2">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-2 text-gray-700 hover:text-[#1f7db6] hover:bg-gray-50 rounded-md font-medium"
              >
                Home
              </Link>
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="px-4 py-2 text-gray-700 hover:text-[#1f7db6] hover:bg-gray-50 rounded-md font-medium"
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to={ctaPath}
                onClick={() => setIsMobileMenuOpen(false)}
                className="mt-2"
              >
                <Button className="w-full bg-[#1f7db6] hover:bg-[#143e6e] text-white font-medium">
                  {ctaLabel}
                  <Icons.ArrowRight className="ml-2" size={18} />
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
